import breakpoints from './components/breakpoints';
import Popup from './classes/class-popup';

const App = (function () {
  const triggers = {
    ajax: 'app.ajax',
    form: {
      success: 'app.form.success',
      error: 'app.form.error',
    },
  };
  const preloader = (() => {
    if (document.getElementById('js-loader')) {
      return document.getElementById('js-loader');
    }
    const loader = document.createElement('div');
    loader.className = 'app-loader';
    loader.id = 'js-loader';
    return loader;
  })();
  const userAgent = (function () {
    const agent = navigator.userAgent.toLowerCase();

    function isMobile() {
      const regex = '/android|webos|iphone|ipad|ipod|blackberry|iemobile|opera/i';
      if (agent.match(regex)) {
        return agent.match(regex)[0];
      }
      return false;
    }

    function isIE() {
      return agent.match('trident') || agent.match('msie');
    }

    return {
      agent,
      isMobile: isMobile(),
      isIE: isIE(),
    };
  }());
  return {
    triggers,
    lang() {
      return document.documentElement.getAttribute('lang');
    },
    userAgent,
    breakpoints,
    preloader: {
      add: () => {
        document.documentElement.appendChild(preloader);
      },
      remove: () => {
        preloader.parentNode.removeChild(preloader);
      },
    },
    stream: (function () {
      const streamArr = [];
      return {
        list: streamArr,
        add(fn) {
          if (typeof fn === 'function') {
            streamArr.push(fn);
            return streamArr.length - 1; // на всякий если надо будет удалить
          }
          return false;
        },
        remove(index) {
          if (streamArr[index]) streamArr.splice(index, 1);
        },
        run: data => streamArr.map((fn) => {
          return { fn, result: fn(data) };
        }),
      };
    }()),
    onAjaxFail(jqXHR) {
      return jqXHR;
    },
  };
}());

$(document).on(App.triggers.ajax, (event, args) => {
  if (!args || !args.html) return false;
  const { html } = args;
  return App.stream.run(html);
});

$(document).on('click contextmenu', '.js-ajax-popup', function (event) {
  const btn = $(this);
  const options = btn.data();
  const url = options.url || btn.attr('href') || '';

  if (options.clicked || !url || url.indexOf('#') === 0) {
    return;
  }

  event.preventDefault();
  btn.data('clicked', true);
  btn.attr('disabled', 'disabled').addClass('is-disabled is-loading');

  $.ajax(url).done((html) => {
    const popup = new Popup(html, { transition: 500 });
    popup.open((opened) => {
      $(document).trigger(App.triggers.ajax, {
        html: opened,
      });
    });
  })
    .always(() => {
      btn.removeData('clicked');
      btn.removeAttr('disabled').removeClass('is-disabled is-loading');
    })
    .fail(App.onAjaxFail);
});


export default App;
